export const scrollIntoView = (index: number, focus: boolean) => {
  const element = document.getElementById(`text-area-${index}`);
  if (element) {
    //When the element is not found, we need to scroll to the first element
    element.scrollIntoView({ behavior: "smooth", block: "start" });
    if (focus) {
      element.focus();
    }
  }
};
